export default __webpack_public_path__ + "static/background_6-276a6b3a268cbe01956bfa1f70150565.png";